import { regionData, codeToText } from "element-china-area-data";
import Clipboard from 'clipboard';
import { Message } from "element-ui";
import Dayjs from "dayjs";
import isBetween from 'dayjs/plugin/isBetween'
// 格式化dictCodeToName
export const dictCodeToName = (code='', arr=[]) => {
  // console.error(code,arr,'=== dictCodeToName ===');
  if (code !== '' && code !== undefined && code !== null && arr?.length) {
    const {label='', val='', full_name='', name='', title=''} = arr.find(({id,key,school_id,value}) => id == code||key == code||value == code||school_id == code)||{};
    return label || val || full_name || name || title || '';
  }
  return '';
}
// code To name
export const codeToName = (code, arr) => {
  if (arr && arr.length) {
    if(typeof code == 'object'&&code.length){
      let nameArr = code.map(item => dictCodeToName(item, arr));
      return nameArr.filter(item => item).join('、');
    }else if (objectType(code)) {
      let nameArr = JSON.parse(code).map(item => dictCodeToName(item, arr));
      return nameArr.filter(item => item).join('、');
    } else {
      let d = arr.find((item) => item.id === code);
      return d ? (d.label||d.val || d.full_name || d.name || "") : "";
    }
  }
  return '';
}
// 将 school_id / grade_arr 统一解析为 number[]（支持数组、JSON 字符串、逗号字符串）
export const parseIdList = (value) => {
  if (value === undefined || value === null || value === '') return [];
  if (Array.isArray(value)) return value.map(Number).filter(n => !isNaN(n));
  if (typeof value === 'number') return [value];
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return [];
    if (objectType(trimmed)) {
      try {
        return JSON.parse(trimmed).map(Number).filter(n => !isNaN(n));
      } catch (e) {
        return [];
      }
    }
    return trimmed.split(/[,，]/).map(s => Number(s.trim())).filter(n => !isNaN(n));
  }
  return [];
}

// 判断的是否是JSON字符串
export const objectType = (str) => {
  if (typeof str == 'string') {
    try {
      var obj = JSON.parse(str);
      // 等于这个条件说明就是JSON字符串 会返回true
      if (typeof obj == 'object' && obj) {
        return true;
      } else {
        //不是就返回false
        return false;
      }
    } catch (e) {
      return false;
    }
  }
  return false;
}
// 判断json对象中所有status属性是否都为true
export const checkAllStatus =(obj) =>{
  if (obj && typeof obj === 'object') {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (key === 'status' && obj[key] !== true) {
          return false;
        } else if (typeof obj[key] === 'object' && obj[key] !== null) {
          if (!checkAllStatus(obj[key])) {
            return false;
          }
        }
      }
    }
  }
  return true;
  // return Object.keys(obj).every(key => key === 'status' && obj[key] === true);
}
// 数字转为中文数字
export const numberToChinese = (number)=> {
  const chineseNumbers = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  const chineseUnits = ['', '十', '百', '千', '万', '亿'];

  let result = '';
  let numStr = number.toString();
  for (let i = 0; i < numStr.length; i++) {
    let digit = parseInt(numStr[i]);
    let unit = chineseUnits[numStr.length - i - 1];
    if (digit === 0) {
      if (result[result.length - 1] !== '零') {
        result += chineseNumbers[digit];
      }
    } else {
      result += chineseNumbers[digit] + unit;
    }
  }
  return result;
}

// 格式化菜单类型
export const formatMenuType = (n)=> {
  let type = '';
  switch(n){
    case 1: // 目录
      type='warning'
      break;
    case 2: // 菜单
      type='success'
      break;
    case 3: // 按钮
      type='danger'
      break;
    case 4: // 外链
      type='primary'
      break;
    case 5: // 页面
      type='info'
      break;
    default:
  }
  return type;
}

// 转换数据类型
export const convertToRealDataType = (obj)=> {
  for (let key in obj) {
    if (typeof obj[key] === 'string') {
      if (obj[key] === 'true') {
        obj[key] = true;
      } else if (obj[key] === 'false') {
        obj[key] = false;
      } else if (!isNaN(obj[key])) {
        obj[key] = Number(obj[key]);
      }
    } else if (typeof obj[key] === 'object') {
      convertToRealDataType(obj[key]);
    }
  }
}
// 区域
export const areaOptionData = () => {
  return [...regionData];
}
// 区域格式化
export const formatAreaCodeToText = (codeStr) => {
  // console.log(codeStr, "codeStr");
  if (objectType(codeStr)) {
    let codeArray = JSON.parse(codeStr);
    return codeArray && codeArray.length ? codeArray.map((item) => codeToText[item]).join("/") : "";
  } else {
    return codeStr;
  }
}
// 区域formatTextToCode
export const formatAreaTextToCode = ({ province, city, district }) => {
  if (province == city) {
    city = '市辖区'
  }
  let p = regionData.find(item => item.label == province) || {};
  let c = p && p.children ? p.children.find(item => item.label == city) : {};
  let d = c && c.children ? c.children.find(item => item.label == district) : {};
  return [p.value, c.value, d.value].filter(item => item);
}

// el-table内容自适应方法  flexWidth
export const flexWidth = (prop, tableData, title, num = 0) =>{
  if (tableData.length === 0) {
    // 表格没数据不做处理
    return
  }
  let flexWidth = 0 // 初始化表格列宽
  let columnContent = '' // 占位最宽的内容
  let canvas = document.createElement('canvas')
  let context = canvas.getContext('2d')
  context.font = '14px Microsoft YaHei'
  if (prop === '' && title) {
    // 标题长内容少的，取标题的值,
    columnContent = title
  } else {
    // 获取该列中占位最宽的内容
    let index = 0
    for (let i = 0; i < tableData.length; i++) {
      const now_temp = tableData[i][prop] + ''
      const max_temp = tableData[index][prop] + ''
      const now_temp_w = context.measureText(now_temp).width
      const max_temp_w = context.measureText(max_temp).width
      if (now_temp_w > max_temp_w) {
        index = i
      }
    }
    columnContent = tableData[index][prop]
    // 比较占位最宽的值跟标题、标题为空的留出四个位置
    const column_w = context.measureText(columnContent).width
    const title_w = context.measureText(title).width
    if (column_w < title_w) {
      columnContent = title || '占位符呀'
    }
  }
  // 计算最宽内容的列宽
  let width = context.measureText(columnContent)
  flexWidth = width.width + 40 + num
  return flexWidth + 'px';
}
// 复制
export const clipboardCopy = (el, text) => {
  const clipboard = new Clipboard(`#${el}`, {
    text: () => `${text}`,
  });
  clipboard.on('success', (e) => {
    Message.success("已复制！");
    clipboard.destroy();
  });
  clipboard.on('error', (e) => {
    Message.success("复制失败!");
    clipboard.destroy();
  });
}

// 当前时间与目标时间之前
export const checkDayisBefore = (targetTime) => {
  return Dayjs().isBefore(Dayjs(targetTime));
}
// 当前时间与目标时间之后
export const checkDayisAfter = (targetTime) => {
  return Dayjs().isAfter(Dayjs(Dayjs(targetTime).add(1,'day')));
}
// 当前时间加上差值如果大于目标时间则是过期
export const checkTimeisExpired = (diff,targetTime)=>{
  // 获取当前时间  
  const now = Dayjs();
  // 将差值(分钟)添加到当前时间【minute (分钟)】
  const timeAfterDiffMinutes = now.add(diff, 'minute');
  // 将给定的时间戳转换为 Day.js 对象  
  const givenTime = Dayjs(targetTime);
  return timeAfterDiffMinutes.isAfter(givenTime) || timeAfterDiffMinutes.isSame(givenTime); 
}

// 计算剩余时间
export const calculateRemainingTime = (targetTime) => {
  const currentTime = Dayjs();
  const remainingTime = Dayjs(targetTime).diff(currentTime);
  const days = Math.floor(remainingTime / (24 * 60 * 60 * 1000));
  const hours = Math.floor((remainingTime % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  const minutes = Math.floor((remainingTime % (60 * 60 * 1000)) / (60 * 1000));
  const seconds = Math.floor((remainingTime % (60 * 1000)) / 1000);
  return {
    days,
    hours,
    minutes,
    seconds
  };
}

// 当前时间是否介于两个时间之间
export const checkIsBetween = (begin,end) => {
  if(begin&&end){
    Dayjs.extend(isBetween);
    return Dayjs().isBetween(Dayjs(begin), Dayjs(end).add(1,'day'));
  }
  return false
}

// 处理数字到最近的整数(默认保留两位小数)
export const toNearestInteger = (num = 0, decimalPlaces = 2, mode = 'round') => {
  // 使用字符串操作避免浮点数精度问题
  const factor = Math.pow(10, decimalPlaces);
  const adjustedNum = parseFloat((num * factor).toPrecision(15));
  
  if (mode === 'round') {
    return Math.round(adjustedNum) / factor;
  } else if (mode === 'floor') {
    return Math.floor(adjustedNum) / factor;
  }
}

// 文件字节大小（返回带单位值）
export const formatBytes = (bytes) => {
  if (bytes >= 1024 * 1024 * 1024) {
    return toNearestInteger(bytes / (1024 * 1024 * 1024)) + 'GB';
  } else if (bytes >= 1024 * 1024) {
    return toNearestInteger(bytes / (1024 * 1024)) + 'MB';
  } else if (bytes >= 1024 ) {
    return toNearestInteger(bytes / 1024) + 'KB';
  } else {
    return bytes + 'B';
  }
}

// url 拼接参数
export const appendQueryParams = (url='', params='') => {
  // 如果url不是 blob 开头的则拼接参数
  if(!/^blob:/.test(url)){
    const mark = url.includes('?') ? '&' : '?';
    // 如果params是字符串，直接拼接  
    if (typeof params === 'string') {  
      return `${url}${mark}${params}`;  
    }  
    // 如果params是对象，遍历并拼接  
    if (typeof params === 'object') {  
      const queryParams = Object.entries(params).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');  
      return `${url}${mark}${queryParams}`;  
    }
  }else{
    return url;
  }
}

// 提取URL中文件信息
export const extractFileInfoFromURL = (url='')=> {
  if (url.startsWith('http')) {
    const { pathname } = new URL(url);
    url = pathname;
  }
  // 正则表达式匹配文件目录和文件名  
  const result = url.match(/^(.*?\/)([^\/]+)$/);
  // result[1] 是目录（包括第一个斜杠），result[2] 是文件名（如果存在）  
  // 如果没有文件名，result[2] 将是undefined  
  // 注意：如果URL没有目录（即直接指向根目录），result[1] 将是 '/'  
  const directory = result ? (result[1] === '/' ? '' : result[1]) : '';  
  const filename = result ? result[2] || '' : '';  
  // 匹配文件后缀
  const suffixMatch = filename.match(/(\.[^.]+)$/);
  const filetype = suffixMatch ? suffixMatch[1] : '';
  return { directory, filename, filetype };
}

// 确保数组对象
export const ensureArray = (value) => {
  if (value&&Array.isArray(value)) {
    return value;
  } else if (value&&Object.keys(value).length) {
    return Array(value)
  } else {
    return []
  }
}

// 按钮状态
export const buttonState = ({key}) => {
  if(key==1){
    return {
      icon:'el-icon-tongguo',
      type:'success',
    }
  }else if(key==2){
    return {
      icon:'el-icon-butongguo',
      type:'danger',
    }
  }else if(key==3){
    return {
      icon:'el-icon-huitui',
      type:'primary',
    }
  }else{
    return {
      icon:'',
      type:'',
    }
  }
}
// 十六进制颜色转换rgba格式 hexToRgba函数
export const hexToRgba = (hex, opacity) => {
  if (hex[0] !== '#') {
    return `rgba(0, 0, 0, ${opacity})`;
  }
  let r = 0, g = 0, b = 0;
  if (hex.length === 4) {
    r = parseInt(hex[1] + hex[1], 16);
    g = parseInt(hex[2] + hex[2], 16);
    b = parseInt(hex[3] + hex[3], 16);
  } else if (hex.length === 7) {
    r = parseInt(hex.slice(1, 3), 16);
    g = parseInt(hex.slice(3, 5), 16);
    b = parseInt(hex.slice(5, 7), 16);
  }
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}